/** Shared design tokens for the Product Details page components. */
export const NAVY = "#0B1F4D";      // Primary
export const BLUE = "#2563EB";      // Secondary (CTAs, links, active states)
export const ACCENT = "#3B82F6";    // Accent (icon glows, highlights on dark bg)
export const BG = "#F8FAFC";        // Section background
export const TEXT = "#111827";      // Body text
export const MUTED = "#6B7280";     // Muted / secondary text
export const BORDER = "#E5E7EB";    // Card borders

/** @deprecated kept as an alias so any stray reference doesn't break; use PALE_BG going forward. */
export const PALE = "#EFF6FF";
export const PALE_BG = "#EFF6FF";

/**
 * Shared page container for the category/subcategory pages. Measured with a
 * real headless-browser audit (not assumed): at 1320px fixed, a 1920px
 * screen has 300px of empty space on each side — correct per spec (1280–
 * 1400px), but confirmed too much margin for this client's taste on large
 * monitors. `2xl:` (Tailwind's ≥1536px breakpoint) widens the cap to 1600px
 * specifically for big screens — re-measured after this change: 1920px now
 * has 160px per side instead of 300px — while 1440px/1280px laptops are
 * unaffected (still 1320px, still within the original 1280–1400px spec).
 * Single definition so every category/subcategory page (current and
 * future) stays consistent automatically.
 */
export const WRAP = "max-w-[1320px] 2xl:max-w-[1600px] mx-auto px-6 lg:px-10 xl:px-12";
